import React from "react";
import { Instagram, Send } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative pt-24 pb-10 overflow-hidden"
      data-testid="footer-section"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 100%, rgba(229,115,36,0.14) 0%, rgba(8,6,5,0) 60%)",
        }}
      />
      <div className="container-custom relative">
        <div
          className="font-serif font-light italic leading-none overflow-visible"
          style={{
            fontSize: "clamp(3.5rem, 12vw, 11rem)",
            color: "rgba(229,115,36,0.1)",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
          aria-hidden="true"
        >
          Вечные Шопен
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-[#F2E9DE]/10 pt-12">
          <div className="md:col-span-2">
            <div className="font-serif text-3xl text-[#F2E9DE] mb-3">
              Вечные <em style={{ color: "#E57324" }}>Шопен</em>
            </div>
            <p className="text-sm text-[#A99F96] max-w-sm">
              Концерт-моноспектакль при свечах.
            </p>
            <p className="text-xs text-[#A99F96]/70 max-w-sm mt-4 leading-relaxed">
              Автор и исполнитель проекта: Валова Вероника Сергеевна
              <br />
              Информация на сайте носит ознакомительный характер и не является публичной офертой. Организатор мероприятия — иммерсивный театр-ресторан «Наблюдатель». Билеты приобретаются через Яндекс.Афишу.
            </p>
          </div>
          <div>
            <div className="eyebrow mb-5">Навигация</div>
            <ul className="space-y-3 text-sm text-[#A99F96]">
              <li>
                <a
                  href="#show"
                  className="hover:text-[#F2E9DE]"
                  data-testid="footer-link-show"
                >
                  О событии
                </a>
              </li>
              <li>
                <a
                  href="#pianista"
                  className="hover:text-[#F2E9DE]"
                  data-testid="footer-link-pianista"
                >
                  Исполнитель
                </a>
              </li>
              <li>
                <a
                  href="#venue"
                  className="hover:text-[#F2E9DE]"
                  data-testid="footer-link-venue"
                >
                  Место проведения
                </a>
              </li>
              <li>
                <a
                  href="#galeria"
                  className="hover:text-[#F2E9DE]"
                  data-testid="footer-link-galeria"
                >
                  Галерея
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-5">Контакты</div>
            <div className="flex flex-col gap-3 mb-4">
              <a
                href="tel:+79168700456"
                className="text-sm text-[#A99F96] hover:text-[#E57324] transition-colors"
              >
                +7 (916) 870-04-56
              </a>
              <a
                href="mailto:verona_piano@mail.ru"
                className="text-sm text-[#A99F96] hover:text-[#E57324] transition-colors"
              >
                verona_piano@mail.ru
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/verona_piano"
                aria-label="instagram"
                data-testid="footer-social-ig"
                className="text-[#A99F96] hover:text-[#E57324] transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://t.me/vechnie_project"
                aria-label="telegram"
                data-testid="footer-social-tg"
                className="text-[#A99F96] hover:text-[#E57324] transition-colors"
              >
                <Send size={20} />
              </a>
            </div>
            <p className="text-[10px] text-[#A99F96]/50 mt-3 leading-relaxed">
              *Признаны экстремистскими организациями и запрещены на территории РФ
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs tracking-[0.2em] uppercase text-[#A99F96]/70">
          <div>© {year} Вечные Шопен · Вероника Валова</div>
          <div className="flex flex-wrap gap-x-8 gap-y-2">
            <Link
              to="/privacy"
              className="hover:text-[#F2E9DE]"
              data-testid="footer-privacy"
            >
              Политика конфиденциальности
            </Link>
            <Link
              to="/consent"
              className="hover:text-[#F2E9DE]"
              data-testid="footer-consent"
            >
              Согласие на обработку персональных данных
            </Link>

          </div>
        </div>
      </div>
    </footer>
  );
}
